import { defineComponent, computed } from 'vue';

var script = defineComponent({
    props: {
        title: {
            type: String,
            default: null,
        },
        subtitle: {
            type: String,
            default: null,
        },
        headerSize: {
            type: String,
            default: 'lg',
        },
        headerStyle: {
            type: String,
            default: 'default',
        },
        center: Boolean,
        noSpacing: Boolean,
    },
    setup(props) {
        const classNames = computed(() => {
            const names = [];
            switch (props.headerSize) {
                case 'sm':
                    names.push('FormHeader--sm');
                    break;
                case 'md':
                    names.push('FormHeader--md');
                    break;
            }
            switch (props.headerStyle) {
                case 'uppercase':
                    names.push('FormHeader--uppercase');
                    break;
            }
            return names;
        });
        return {
            classNames,
        };
    },
});

export { script as default };
